import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Percolation, PercolationGrid } from '../../components/examples/';
export const _frontmatter = {
  "Title": "Percolation"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "percolation"
    }}>{`Percolation`}</h1>
    <p>{`A 2D lattice is made of cells which either let liquid go through (porous) or not.
If we pour liquid on the top of the lattice, will any of it go through? This depends on the porosity of the lattice, i.e. the percentage of cells which are porous.`}</p>
    <Percolation mdxType="Percolation" />
    <p>{`Interestingly, the chances of liquid getting through don't vary linearly with the porosity. If porosity is beyond a certain `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Percolation_threshold"
      }}>{`threshold`}</a>{`, there are very little chances that the liquid gets through, and beyond that threshold it becomes very likely.
For our 2D lattice with liquid being able to go in all 4 directions, the threshold is around `}<em parentName="p">{`0.59`}</em>{`.`}</p>
    <p>{`To see how dramatically the chances of liquid percolating increase once we're past the threshold, let's simulate 100 pours at a time:
On that grid, every column has the same porosity index.`}</p>
    <PercolationGrid mdxType="PercolationGrid" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      